// extracted by mini-css-extract-plugin
module.exports = {"Span":"spinner_Span__MP8m0","spinner":"spinner_spinner__1HIll"};